import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import React from "react";

const Eshagun = () => {
  return (
    <Tabs p={2}>
      <TabList mb="1em">
        <Tab w={"50%"}>Eshagun Sent</Tab>
        <Tab w={"50%"}>Eshagun Receive</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <p>Sent!</p>
        </TabPanel>
        <TabPanel>
          <p>Receive!</p>
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default Eshagun;
